//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SEARCH_TERM_QUERY_PARAM } from '@/scripts/constants/search'
import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'
import {
  ACTION_RESET_MENU_ID,
  ACTION_SET_HEADER_FIXED_POSITION,
  ACTION_SET_HEADER_STATIC_POSITION,
  ACTION_UPDATE_KEYBOARD_NAVIGATION,
  ACTION_UPDATE_HEADER_IS_COLLAPSED,
  ACTION_ADJUST_HEADER_PADDING,
  ACTION_SHOW_ACCOUNT_BULLET,
} from '@/scripts/store/header/actions'
import { createNamespacedHelpers, mapActions, mapGetters } from 'vuex'
import RbHeaderDynamicMenuRenderer from './dynamic-menu-renderer/dynamic-menu-renderer'
const RbSearchPanel = () => import('@/elements/header/search/search-panel.lazy.vue')
import RbHeaderActions from '@/elements/header/actions/actions.vue'
import RbHeaderAccountSidePanel from '@/elements/header/panels/account-side-panel.vue'
import RbHeaderOmnichannelSidePanel from '@/elements/header/panels/omnichannel-side-panel.vue'
import RbHeaderNavigationMenuPanel from '@/elements/header/panels/navigation-menu-panel.vue'
import RbHeaderNavigationSubmenuPanel from '@/elements/header/panels/navigation-submenu-panel.vue'
import RbHeaderEyemedBar from '@/elements/header/eyemed-bar/eyemed-bar.vue'

import RbHeaderDynamicSubmenuTitle from '@/elements/header/dynamic-submenu-title/dynamic-submenu-title'
import RbHeaderDynamicNavigationSubmenuPanel from '@/elements/header/panels/dynamic-navigation-submenu-panel'
import RbHeaderMessageBar from '@/elements/header/message-bar/message-bar.vue'
import RbHeaderOmnichannel from '@/elements/header/omnichannel/omnichannel.vue'
import RbHeaderMessageBarButton from '@/elements/header/message-bar-button/message-bar-button.vue'

import wcs from '@/scripts/libs/wcs'
import {
  EVENTS,
  RB_HEADER_NAVIGATION,
  RB_HEADER_MESSAGE_BAR_CONTAINER,
  RB_APP__HEADER,
} from '@/scripts/constants/css-classes'
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'
import { CART_SAVED, MINIWISHLIST_SAVED } from '@/scripts/constants/cookies'
import { Cookies } from '@/scripts/libs/cookies'
import {
  ACTION_EVALUATE_EARLY_ACCESS,
  ACTION_EVALUATE_PROMO_CODE,
  ACTION_LOAD_MINICART,
  ACTION_LOAD_MINIWISHLIST,
  ACTION_LOAD_SELF_AND_MY_ACCOUNT,
  ACTION_SHOW_PAYMENT_MESSAGE_BOX,
} from '@/scripts/store/actions'
import { ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE } from '@/scripts/store/eyewear-protection/actions'
import { Wishlist } from '@/scripts/libs/analytics/wishlist'
import {
  HEADER_MINIMUM_Z_INDEX,
  NAVIGATION_COLLAPSED_OFFSET,
  HEADER_SUBMENU_PANEL_ANIMATION_TIME_IN_MILLISECONDS,
} from '@/scripts/constants/header'
import WCAGHeader from '@/scripts/libs/wcag/header'
import { detectScrollVelocity } from './detect-scroll-velocity'
import { SHIPPING_METHODS } from '@/scripts/constants/shipping-methods'
import FocusOutline from '@/scripts/libs/a11y/focus-outline'
import { ACTION_CHECK_EYEMED_COOKIE } from '@/scripts/store/actions/pdp'
import { DOM } from '@/scripts/libs/dom'
import Genesys from '@/scripts/libs/genesys'
import { TRUE_LOWERCASE } from '@/scripts/constants/booleans'
import DoctorLocator from '@/scripts/libs/doctor-locator'
import RbMonetate from '@/elements/monetate/rb-monetate'
import { ShippingMethods } from '@/scripts/libs/shipping-methods'
import WCAG from '@/scripts/libs/wcag/wcag'
import AlgoliaAnalytics from '@/scripts/libs/algolia/analytics'
import { PRODUCTS_QUERYID } from '@/scripts/constants/algolia'
const {
  eyewearProtection,
  pagesWithoutChat,
  viewTaskName,
  stickyStripeEnabled,
  stickyHeaderEnabled,
} = wcs.getStoreConfig()

const { mapGetters: mapGettersHeader, mapActions: mapActionsHeader } =
  createNamespacedHelpers('header')
const { mapActions: mapActionsEyewearProtection } = createNamespacedHelpers('eyewearProtection')
const { mapGetters: mapGettersVirtualMirror } = createNamespacedHelpers('virtualMirror')
const { mapActions: mapActionsPdp, mapGetters: mapGettersPDP } = createNamespacedHelpers('pdp')
const { mapGetters: mapGettersSidebar } = createNamespacedHelpers('sidebar')
const { mapGetters: mapGettersFrameGenius } = createNamespacedHelpers('frameGenius')
const { mapGetters: mapGettersDoctorLocator } = createNamespacedHelpers('doctorLocator')
const MAX_SCROLL_SPEED = 150
const FIXED_CLASS = 'rb-app__header--fixed'
const STATIC_CLASS = 'rb-app__header--static'
export default {
  name: 'rb-header',
  components: {
    RbHeaderDynamicMenuRenderer,
    RbHeaderMessageBarButton,
    RbHeaderMessageBar,
    RbHeaderOmnichannel,
    RbSearchPanel,
    RbHeaderActions,
    RbHeaderAccountSidePanel,
    RbHeaderOmnichannelSidePanel,
    RbHeaderNavigationMenuPanel,
    RbHeaderNavigationSubmenuPanel,
    RbHeaderDynamicSubmenuTitle,
    RbHeaderDynamicNavigationSubmenuPanel,
    RbHeaderEyemedBar,
    RbMonetate,
  },
  props: {
    // TODO: check if this can be removed
    isEyeMedEnabled: {
      type: Boolean,
      default: false,
    },
    isStaticPosition: {
      type: Boolean,
      default: false,
    },
    homePageUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentWCAGIdOfMainMenu: null,
      currentScroll: 0,
      isAccountPanelOpen: false,
      isBestSellerCarouselVisible: false,
      isEditorialWallVisible: false,
      isHamburgerMenuRedDotVisible: false,
      isNavigationMenuPanelOpen: false,
      isNavigationSubmenuPanelOpen: false,
      isOmnichannelOpen: false,
      isOmnichannelSubmenuOpen: false,
      isSearchPanelOpen: false,
      headerAppElement: undefined,
      headerNavigationElement: undefined,
      messageBarElement: undefined,
      offsets: {
        messageBar: 0,
        navigation: 0,
      },
      innerHeight: window.innerHeight,

      // TODO: avoid constant propagation inside data
      HEADER_MINIMUM_Z_INDEX,
      bookAnExamQueryParam: 'showDoctorLocatorModal',
      lastScrollY: 0,
      stickyHeader: false,
    }
  },
  computed: {
    ...mapActions([ACTION_SHOW_PAYMENT_MESSAGE_BOX]),
    ...mapGetters(['orderId', 'translation', 'getUi', 'showSidebar', 'eyeMedIsVisible']),
    ...mapGettersHeader([
      'currentMenuId',
      'keyboardNavigation',
      'headerIsCollapsed',
      'isInBackground',
    ]),
    ...mapGettersVirtualMirror(['isVisible']),
    ...mapGettersPDP(['minicartIsVisible', 'getAfterPayModalActive']),
    ...mapGettersSidebar(['isFrameAdvisorOpen']),
    ...mapGettersDoctorLocator(['getIsVisibleDoctorLocator']),
    ...mapGettersFrameGenius(['isFloatingButtonVisible']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
    promoBulletIsVisible() {
      // TODO: return true only if there is "promo" inside the main menu items
      return true
    },
    currentMenuIdHasValue() {
      return (
        this.currentMenuId !== undefined && this.currentMenuId !== null && this.currentMenuId !== ''
      )
    },
    isOverlayVisible() {
      const isSearchOrAccountPanelOpen = this.isSearchPanelOpen || this.isAccountPanelOpen

      if (this.isMobile) {
        return isSearchOrAccountPanelOpen || this.isNavigationMenuPanelOpen
      }
      return isSearchOrAccountPanelOpen || !!this.currentMenuId
    },
    isAPanelOpen() {
      return (
        this.isOmnichannelOpen ||
        this.isAccountPanelOpen ||
        this.isNavigationMenuPanelOpen ||
        this.isSearchPanelOpen
      )
    },
    isNoEcommerce() {
      return NoEcommerce.isStoreNoEcommerce()
    },
    isInCart() {
      return wcs.isInCart()
    },
    isEditorialSectionNotPresent() {
      // TODO: check this
      return !this.isBestSellerCarouselVisible && !this.isEditorialWallVisible
    },
    isMessageBarVisible() {
      return !(this.isMobile && wcs.isInFluidPcp())
    },
    showStickyMenuHeader() {
      return this.isMobile || wcs.isInPlp() || wcs.isStaticPage()
    },
    pageIsPlp() {
      return wcs.isInPlp()
    },
    canShowGenesys() {
      return !pagesWithoutChat?.includes(viewTaskName)
    },
    wcagHiddenButtonIsFocusable() {
      if (this.isMobile) {
        return false
      }
      return !!this.isAPanelOpen || !!this.currentMenuIdHasValue
    },
    mainMenuIds() {
      const buttons = Array.from(this.$refs.mainMenu?.querySelectorAll('.main-menu__button'))
      return buttons?.map((button) => +button.id)
    },
    isPcpMobile() {
      return this.isMobile && wcs.isInFluidPcp()
    },
    classNameIsStatic() {
      if (wcs.isInPlp()) {
        return !stickyStripeEnabled ? STATIC_CLASS : FIXED_CLASS
      }
      if (this.isStaticPosition) {
        return STATIC_CLASS
      } else if (!this.isStaticPosition && !this.isPcpMobile) {
        return FIXED_CLASS
      }
      return ''
    },
    classNameCollapsed() {
      return !!this.headerIsCollapsed && !this.getUi.newsletterOpenStatus && !this.isVisible
        ? 'rb-app__header--is-collapsed'
        : ''
    },
    classNameBackground() {
      return (!!this.isInBackground && !this.eyeMedIsVisible) ||
        !!this.getUi.isDashButtonSmall ||
        !!this.showSidebar ||
        !!this.isVisible ||
        !!this.minicartIsVisible ||
        !!this.isFrameAdvisorOpen ||
        !!this.isFloatingButtonVisible ||
        !!this.getIsVisibleDoctorLocator
        ? 'rb-app__header--background'
        : ''
    },
  },
  watch: {
    currentMenuId(value) {
      if (value) {
        this.closeAccountPanel()
        this.freezeScroll()

        if (this.isMobile) {
          this.openNavigationSubmenuPanel()
        }
      } else {
        this.freeScroll()
      }
    },
    currentScroll(current, previous) {
      if (this.showStickyMenuHeader) {
        this.handleDoubleStageHeaderScrollAnimation(current, previous)
        return
      }

      this.handleSingleStageHeaderScrollAnimation(current, previous)
    },
    isNavigationMenuPanelOpen(value) {
      this.setTrustBadgeDivHiddenProperty(value)
    },
    isSearchPanelOpen(value) {
      this.setTrustBadgeDivHiddenProperty(value)
    },
    isAPanelOpen(aPanelIsOpen) {
      this.updateHeaderIsCollapsed(false)
      if (aPanelIsOpen) {
        this.freezeScroll()
      } else {
        this.freeScroll()
      }
    },
    isOmnichannelOpen(value) {
      if (!value) {
        this.$nextTick(() => {
          this.setFocusToOmnichannel()
        })
      }
    },
    isAccountPanelOpen(value) {
      if (!value) {
        this.$nextTick(() => {
          this.setFocusToAccountIcon()
        })
      }
    },
    orderId(val) {
      if (!val || !this.isInCart || !eyewearProtection.isEnabled) {
        return
      }

      this.fetchAndSetAvailabilityResponse(val)
    },
  },
  created() {
    FocusOutline.init()
    this.loadSelfAndMyAccount()
    this.evaluateEarlyAccess()
    window.externalInvocationMethodMapping.closeConfigure = () => {
      window.onLogoClick()
    }
    window.externalInvocationMethodMapping.copyPromoCode = (promocode) => {
      this.evaluatePromoCode(promocode)
    }
  },
  mounted() {
    this.headerAppElement = document.querySelector(`.${RB_APP__HEADER} .rb-header`)
    this.setCssVariableForHeaderHeight(this.headerAppElement?.offsetHeight)
    this.stickyHeader = stickyStripeEnabled && wcs.isInPlp()
    this.setCssVariableForPaddingIsFixed(
      this.classNameIsStatic === FIXED_CLASS ? this.headerAppElement?.offsetHeight : 0
    )
    setTimeout(this.trackElementsAndOffsets, 100)

    this.checkAndSetHamburgerMenuDotVisibility()
    this.handleHeaderAppPosition()
    this.adjustHeaderPadding()
    this.checkEyemedCookie()

    document.addEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
    document.addEventListener(EVENTS.REMOVE_FROM_CART, this.onRemoveFromCart)
    document.addEventListener(EVENTS.ADD_TO_BAG, this.onAddToBag)
    document.addEventListener(EVENTS.TOOGLE_HEADER, this.toogleHeader)

    this.$refs?.header?.addEventListener(EVENTS.KEY_UP, this.handleWcagNavigation)
    window.externalInvocationMethodMapping.openGenesysChat = () => {
      Genesys.injectAndInit({ vuexStore: this.$store, multiAnalytics: this.$ma })
    }
    if (Genesys.genesysWasInitialized() && this.canShowGenesys) {
      Genesys.injectAndInit({ vuexStore: this.$store, multiAnalytics: this.$ma })
    }

    if (wcs.isInTYP()) {
      const cart = localStorage.getItem(CART_SAVED)
      const cartData = JSON.parse(cart || '{}')
      AlgoliaAnalytics.trackPurchase(cartData)
      ShippingMethods.clearSavedMethodFromStorage()
      localStorage.removeItem(PRODUCTS_QUERYID)
    }

    if (
      SHIPPING_METHODS.SHIPPING_AVAILABLE_IN_PAYMENT.includes(
        ShippingMethods.getSelectedShippingMethod()
      )
    ) {
      this.ACTION_SHOW_PAYMENT_MESSAGE_BOX()
    }

    window.externalInvocationMethodMapping.showDoctorLocatorModal = () => {
      DoctorLocator.inject({
        vuexStore: this.$store,
      })
    }

    const queryParams = new URLSearchParams(window.location.search)
    const bookAnExamOpenedQueryParam = queryParams.get(this.bookAnExamQueryParam)

    if (bookAnExamOpenedQueryParam === TRUE_LOWERCASE) {
      this.$nextTick(() => {
        DoctorLocator.inject({
          vuexStore: this.$store,
        })
      })
    }

    const redDotEnabledFromPCP = sessionStorage.getItem('redDotEnabledFromPCP') === TRUE_LOWERCASE

    if (redDotEnabledFromPCP) {
      this.showAccountBullet()
      sessionStorage.removeItem('redDotEnabledFromPCP')
    }

    const searchTermQueryParam = queryParams.get(SEARCH_TERM_QUERY_PARAM)
    if (searchTermQueryParam) {
      this.openSearchPanel()
    }
  },
  beforeDestroy() {
    FocusOutline.destroy()

    clearTimeout(this.trackElementsAndOffsets, 100)

    document.removeEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
    document.removeEventListener(EVENTS.REMOVE_FROM_CART, this.onRemoveFromCart)
    document.removeEventListener(EVENTS.ADD_TO_BAG, this.onAddToBag)

    this.$refs?.header.removeEventListener(EVENTS.KEY_UP, this.handleWcagNavigation)
  },
  methods: {
    ...mapActions({
      loadCart: ACTION_LOAD_MINICART,
      loadWishlist: ACTION_LOAD_MINIWISHLIST,
      loadSelfAndMyAccount: ACTION_LOAD_SELF_AND_MY_ACCOUNT,
      evaluateEarlyAccess: ACTION_EVALUATE_EARLY_ACCESS,
      evaluatePromoCode: ACTION_EVALUATE_PROMO_CODE,
    }),
    ...mapActionsPdp({
      checkEyemedCookie: ACTION_CHECK_EYEMED_COOKIE,
    }),
    ...mapActionsHeader({
      resetMenuId: ACTION_RESET_MENU_ID,
      setHeaderToStaticPosition: ACTION_SET_HEADER_STATIC_POSITION,
      setHeaderToFixedPosition: ACTION_SET_HEADER_FIXED_POSITION,
      updateKeyboardNavigation: ACTION_UPDATE_KEYBOARD_NAVIGATION,
      updateHeaderIsCollapsed: ACTION_UPDATE_HEADER_IS_COLLAPSED,
      adjustHeaderPadding: ACTION_ADJUST_HEADER_PADDING,
      showAccountBullet: ACTION_SHOW_ACCOUNT_BULLET,
    }),
    ...mapActionsEyewearProtection({
      fetchAndSetAvailabilityResponse: ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE,
    }),
    toogleHeader(event) {
      const headerH = this.headerAppElement.offsetHeight ?? 0
      this.updateHeaderIsCollapsed(true)
      this.setCssVariableForCollapsedHeader(-headerH)
      if (event.detail.display) {
        this.setCssVariableForCollapsedHeader(0)
        this.updateHeaderIsCollapsed(false)
      }
    },
    RB_APP__HEADER() {
      return RB_APP__HEADER
    },
    trackElementsAndOffsets() {
      this.headerNavigationElement = document.querySelector(`.${RB_HEADER_NAVIGATION}`)
      this.messageBarElement = document.querySelector(`.${RB_HEADER_MESSAGE_BAR_CONTAINER}`)

      this.offsets = {
        navigation: parseInt(this.headerNavigationElement?.getBoundingClientRect()?.bottom),
        messageBar: parseInt(this.headerNavigationElement?.getBoundingClientRect()?.top),
      }
    },
    closeMenuPanel(e) {
      const linkUrl = e.target.getAttribute('href')
      const isFrameAdvisorLink = linkUrl?.includes('initFrameAdvisor')
      if (isFrameAdvisorLink && !this.isMobile) {
        this.closePanels()
      }
    },
    handleHeaderAppPosition() {
      const headerAppHeight = this.headerAppElement?.getBoundingClientRect()?.height || 0
      if (this.isStaticPosition) {
        this.setCssVariableForHeaderHeight(headerAppHeight)
        return
      }
    },
    handleWcagNavigation(e) {
      if (this.isOmnichannelOpen) {
        this.closeOmnichannel()
        return
      }

      if (this.isAccountPanelOpen) {
        this.closeAccountPanel()
        return
      }

      if (WCAG.isEnterPressed(e) && WCAGHeader.focusedElementIsInsideMainMenu()) {
        this.currentWCAGIdOfMainMenu = +e?.target?.id
      }

      if (WCAG.isEscPressed(e)) {
        this.resetMenuId()

        if (this.keyboardNavigation?.focusedElementIsInsideSubmenu) {
          this.focusNextItem()
        }
      }

      const canFocusNextItem =
        WCAG.isTabPressed(e) && this.keyboardNavigation?.focusedElementIsLastInsideSubmenu
      if (canFocusNextItem) {
        this.focusNextItem()
      }

      if (
        WCAGHeader.focusedElementIsInsideMainMenu() &&
        this.currentWCAGIdOfMainMenu !== +e?.target?.id
      ) {
        this.resetMenuId()
      }

      if (
        !WCAGHeader.focusedElementIsInsideMainMenu() &&
        !WCAGHeader.focusedElementIsInsideSubmenu()
      ) {
        this.resetMenuId()
      }

      this.updateKeyboardNavigationStatus()
    },
    updateKeyboardNavigationStatus() {
      const keyboardNavigationStatus = {
        currentId: this.currentWCAGIdOfMainMenu,
        focusedElementIsInsideMainMenu: WCAGHeader.focusedElementIsInsideMainMenu(),
        focusedElementIsInsideSubmenu: WCAGHeader.focusedElementIsInsideSubmenu(),
        focusedElementIsLastInsideSubmenu: this.isEditorialSectionNotPresent
          ? WCAGHeader.focusedElementIsLastItemInsideSubmenuWithoutEditorial()
          : WCAGHeader.focusedElementIsLastItemInsideSubmenuWithEditorial(),
        menuIds: this.mainMenuIds,
      }

      this.updateKeyboardNavigation(keyboardNavigationStatus)
    },
    focusNextItem() {
      const isLastMenuId =
        this.currentWCAGIdOfMainMenu === this.mainMenuIds[this.mainMenuIds.length - 1]
      if (isLastMenuId) {
        this.setFocusToSearchIcon()
        return
      }

      const nextMenuId = this.currentWCAGIdOfMainMenu + 1
      const element = document.getElementById(nextMenuId)
      element?.focus()
    },
    async onRemoveFromCart() {
      Cookies.remove(MINIWISHLIST_SAVED)
      await this.loadWishlist()
      Cookies.remove(CART_SAVED)
      await this.loadCart()
    },
    async onAddToBag(param) {
      if (param && param.detail && param.detail.isAddToBagFromMySelection) {
        if (param.detail.catEntryId1) {
          Wishlist.trackAddToCartFromMySelectionsBothProducts(
            this.$ma,
            this.itemsWishlist,
            param.detail.catEntryId1,
            param.detail.catEntryId2
          )
        } else if (param.detail.catEntryId) {
          Wishlist.trackAddToCartFromMySelections(
            this.$ma,
            this.itemsWishlist,
            param.detail.catEntryId
          )
        }
      }
      Cookies.remove(CART_SAVED)
      await this.loadCart()
      Cookies.remove(MINIWISHLIST_SAVED)
      await this.loadWishlist()
      if (param?.detail?.withRedirectToCart) {
        window.location.href = wcs.getEndPoint('shopCartView')
      }
    },
    setBestSellerCarouselVisibility(isBestSellerCarouselVisible) {
      this.isBestSellerCarouselVisible = isBestSellerCarouselVisible
    },
    setEditorialWallVisibility(isEditorialWallVisible) {
      this.isEditorialWallVisible = isEditorialWallVisible
    },
    checkAndSetHamburgerMenuDotVisibility() {
      const isAnyHighlightedMenuItemPresent = this.$slots['main-menu']?.some(
        (slot) => slot?.componentOptions?.propsData?.isHighlighted
      )
      this.isHamburgerMenuRedDotVisible = isAnyHighlightedMenuItemPresent
    },
    freezeScroll() {
      if (this.isMobile) {
        DOM.freezePageScroll()
      }
    },
    freeScroll() {
      if (this.isMobile) {
        DOM.freePageScroll()
      }
    },
    openOmnichannel() {
      this.isOmnichannelOpen = true
      this.resetMenuId()
      this.freezeScroll()
    },
    closeOmnichannel() {
      this.isOmnichannelOpen = false
      this.freeScroll()
    },
    toggleOmnichannel() {
      if (this.isOmnichannelOpen) {
        this.closeOmnichannel()
      } else {
        this.closeAccountPanel()
        this.openOmnichannel()
      }
    },
    openOmnichannelSubmenu() {
      this.isOmnichannelSubmenuOpen = true
      this.freezeScroll()
    },
    closeOmnichannelSubmenu() {
      this.isOmnichannelSubmenuOpen = false
      this.freeScroll()
    },
    toggleOmnichannelSubmenu() {
      if (this.isOmnichannelSubmenuOpen) {
        this.closeOmnichannelSubmenu()
      } else {
        this.closeAccountPanel()
        this.openOmnichannelSubmenu()
      }
    },
    openAccountPanel() {
      this.isAccountPanelOpen = true
      this.resetMenuId()
      this.freezeScroll()
    },
    closeAccountPanel() {
      this.isAccountPanelOpen = false
      this.freeScroll()
    },
    toggleAccountPanel() {
      this.isAccountPanelOpen ? this.closeAccountPanel() : this.openAccountPanel()
    },
    openSearchPanel() {
      this.closeAccountPanel()
      this.closeNavigationMenuPanel()
      this.resetMenuId()
      this.isSearchPanelOpen = true
      this.freezeScroll()
    },
    closeSearchPanel() {
      this.isSearchPanelOpen = false
      this.freeScroll()
      this.setFocusToSearchIcon()
    },
    setFocusToSearchIcon() {
      const searchIcon = this.$refs?.desktopActions?.$refs?.searchIcon
      searchIcon?.focus()
    },
    setFocusToAccountIcon() {
      const accountIcon = this.$refs?.desktopActions?.$refs?.accountIcon
      accountIcon?.focus()
    },
    setFocusToOmnichannel() {
      const omnichannelCTA = this.$refs?.messageBar?.$refs?.omnichannelCTA.$refs?.cta
      omnichannelCTA?.focus()
    },
    openNavigationMenuPanel() {
      this.isNavigationMenuPanelOpen = true
      this.freezeScroll()
    },
    closeNavigationMenuPanel() {
      this.isNavigationMenuPanelOpen = false
      this.freeScroll()
    },
    openNavigationSubmenuPanel() {
      this.isNavigationSubmenuPanelOpen = true
    },
    closeNavigationSubmenuPanel() {
      this.isNavigationSubmenuPanelOpen = false
    },
    closeSubmenuPanelAndResetMenuId() {
      this.closeNavigationSubmenuPanel()

      setTimeout(() => {
        this.resetMenuId()
      }, HEADER_SUBMENU_PANEL_ANIMATION_TIME_IN_MILLISECONDS)
    },
    closePanels() {
      if (this.isAccountPanelOpen) {
        this.closeAccountPanel()
      }
      if (this.isOmnichannelOpen) {
        this.closeOmnichannel()
      }
      if (this.isSearchPanelOpen) {
        this.closeSearchPanel()
      }
      if (this.isNavigationSubmenuPanelOpen) {
        this.closeNavigationSubmenuPanel()
      }
      if (this.isNavigationMenuPanelOpen) {
        this.closeNavigationMenuPanel()
      }
      if (this.isOmnichannelSubmenuOpen) {
        this.closeOmnichannelSubmenu()
      }
    },
    closePanelsAndResetMenuId() {
      this.closePanels()

      setTimeout(() => {
        this.resetMenuId()
      }, HEADER_SUBMENU_PANEL_ANIMATION_TIME_IN_MILLISECONDS)
    },
    navigateToCart() {
      const cartUrl = wcs.getEndPoint('shopCartView')
      window.location.href = cartUrl
    },
    updateCurrentScroll() {
      this.currentScroll = window.scrollY
      if (wcs.isInPlp()) {
        this.evaluateScroll()
      }
    },
    setCssVariableForVisibleHeaderOnScroll(height = 0) {
      document.documentElement.style.setProperty('--header-visible-scroll', `${height}px`)
    },
    setCssVariableForCollapsedHeader(height) {
      document.documentElement.style.setProperty('--header-collapsed', `${height}px`)
    },
    setCssVariableForHeaderHeight(height) {
      document.documentElement.style.setProperty('--header-height', `${height}px`)
    },
    setCssVariableForPaddingIsFixed(height) {
      document.documentElement.style.setProperty('--header-height-fixed', `${height}px`)
    },
    handleSingleStageHeaderScrollAnimation(currentScroll, previousScroll) {
      // TODO: avoid direct DOM manipulation
      const navigationElementMeasures = this.headerNavigationElement?.getBoundingClientRect()

      if (this.isStaticPosition) {
        this.offsets = {
          messageBar:
            navigationElementMeasures?.top > 0 ? parseInt(navigationElementMeasures.top) : 0,
          navigation:
            navigationElementMeasures?.bottom > 0 ? parseInt(navigationElementMeasures?.bottom) : 0,
        }
        return
      }

      const messageBarElementMeasures = this.messageBarElement?.getBoundingClientRect()
      const messageBarHeight = messageBarElementMeasures?.height ?? 0
      const isScrollingDown = previousScroll < currentScroll
      const headerH = this.headerAppElement.offsetHeight ?? 0
      if (isScrollingDown) {
        const scrollHasPassedMessageBarElement = currentScroll > headerH - messageBarHeight
        if (scrollHasPassedMessageBarElement) {
          this.offsets = {
            messageBar: 0,
            navigation: NAVIGATION_COLLAPSED_OFFSET.DESKTOP + messageBarHeight,
          }
          if (!this.isAPanelOpen && !this.isStaticPosition) {
            this.updateHeaderIsCollapsed(true)
            this.setCssVariableForCollapsedHeader(-messageBarHeight)
          }
        }
      } else {
        const scrollHasReachedMessageBarElement = currentScroll < headerH - messageBarHeight
        const scrollVelocity = detectScrollVelocity()
        if (scrollHasReachedMessageBarElement || Math.abs(scrollVelocity) > MAX_SCROLL_SPEED) {
          this.offsets = {
            messageBar: parseInt(messageBarHeight),
            navigation: parseInt(messageBarHeight) + parseInt(navigationElementMeasures?.height),
          }
          if (!this.isAPanelOpen) {
            this.updateHeaderIsCollapsed(false)
            this.setCssVariableForCollapsedHeader(0)
          }
        } else {
          if (!this.isAPanelOpen) {
            this.updateHeaderIsCollapsed(true)
            this.setCssVariableForCollapsedHeader(-messageBarHeight)
          }
        }
      }
    },
    handleDoubleStageHeaderScrollAnimation(currentScroll, previousScroll) {
      // TODO: avoid direct DOM manipulation

      const navigationElementMeasures = this.headerNavigationElement?.getBoundingClientRect()

      if (this.isStaticPosition) {
        this.offsets = {
          messageBar:
            navigationElementMeasures?.top > 0 ? parseInt(navigationElementMeasures?.top) : 0,
          navigation:
            navigationElementMeasures?.bottom > 0 ? parseInt(navigationElementMeasures?.bottom) : 0,
        }
        return
      }

      const messageBarElementMeasures = this.messageBarElement?.getBoundingClientRect()
      const messageBarHeight = messageBarElementMeasures?.height ?? 0
      const headerAppHeight = this.headerAppElement.getBoundingClientRect()?.height
      const isScrollingDown = previousScroll < currentScroll

      if (isScrollingDown) {
        if (this.isAPanelOpen) return

        const scrollHasPassedHeaderHeight =
          currentScroll > this.$refs?.header?.getBoundingClientRect()?.bottom
        if (scrollHasPassedHeaderHeight) {
          if (!this.isAPanelOpen) {
            const collapsedHeaderOffset = this.currentMenuIdHasValue
              ? -messageBarHeight
              : -headerAppHeight
            if (!wcs.isInPlp()) {
              this.updateHeaderIsCollapsed(true)
              this.setCssVariableForCollapsedHeader(collapsedHeaderOffset)
            }
          }
        }
      } else {
        if (this.isAPanelOpen) return

        const scrollHasReachedHeaderHeight =
          currentScroll <= this.$refs?.header?.getBoundingClientRect()?.height
        if (scrollHasReachedHeaderHeight) {
          this.offsets = {
            messageBar: messageBarHeight,
            navigation:
              messageBarHeight +
              (this.isMobile
                ? NAVIGATION_COLLAPSED_OFFSET.MOBILE
                : NAVIGATION_COLLAPSED_OFFSET.DESKTOP),
          }

          this.updateHeaderIsCollapsed(false)
          this.setCssVariableForCollapsedHeader(0)
          if (!wcs.isInPlp()) {
            this.updateHeaderIsCollapsed(false)
            this.setCssVariableForCollapsedHeader(0)
          }
        } else {
          this.offsets = {
            messageBar: parseInt(messageBarHeight),
            navigation: parseInt(navigationElementMeasures?.height + messageBarHeight),
          }
          if (!this.isAPanelOpen) {
            if (!wcs.isInPlp()) {
              this.updateHeaderIsCollapsed(true)
              this.setCssVariableForCollapsedHeader(-messageBarHeight)
            }
          }
        }
      }
    },
    setTrustBadgeDivHiddenProperty(hasTrustBadgeDivToBeHidden) {
      if (this.isMobile) {
        const trustBadgeDiv = document.querySelector('[id^="trustbadge-container-"]')
        if (trustBadgeDiv) {
          trustBadgeDiv.hidden = hasTrustBadgeDivToBeHidden
        }
      }
    },
    evaluateScroll() {
      // StickyHeaderEnabled - attiva la logica e gestisce la stripe
      // StickyStripeEnabled - contrariamente ad pgni senso logica gestisca l'attivazione della featrue
      if (this.isAPanelOpen) {
        return
      }
      const currentScrollY = window.scrollY
      const messageBarElementMeasures = this.messageBarElement?.getBoundingClientRect()
      const headerAppHeight = this.headerAppElement?.getBoundingClientRect()?.height || 0
      const headerElement = document.querySelector('.rb-header__navigation')
      const stripeElement = document.querySelector('.promo-stripe')
      const messageBarHeight = messageBarElementMeasures?.height ?? 0
      const stripeHeight = stripeElement ? stripeElement.clientHeight : 0
      const headerHeight = headerElement ? headerElement.clientHeight : 0
      if (stickyStripeEnabled) {
        this.updateHeaderIsCollapsed(true)
        this.setCssVariableForVisibleHeaderOnScroll(0)
        if (currentScrollY < this.lastScrollY) {
          // up
          if (!this.stickyHeader) {
            const currH = headerAppHeight - stripeHeight
            this.setCssVariableForCollapsedHeader(-messageBarHeight)
            this.setCssVariableForVisibleHeaderOnScroll(currH)
          } else {
            this.updateHeaderIsCollapsed(true)
            this.setCssVariableForCollapsedHeader(-stripeHeight)
            this.setCssVariableForVisibleHeaderOnScroll(headerHeight + stripeHeight)
            if (!stripeHeight) {
              this.setCssVariableForCollapsedHeader(-messageBarHeight)
            }
          }
        } else {
          this.updateHeaderIsCollapsed(true)
          this.setCssVariableForVisibleHeaderOnScroll(0)
          if (this.stickyHeader) {
            if (stripeHeight && stickyHeaderEnabled) {
              this.setCssVariableForCollapsedHeader(-(headerAppHeight - stripeHeight))
              this.setCssVariableForVisibleHeaderOnScroll(stripeHeight)
            } else {
              this.setCssVariableForVisibleHeaderOnScroll(0)
              this.setCssVariableForCollapsedHeader(-headerAppHeight)
            }
          } else {
            this.setCssVariableForVisibleHeaderOnScroll(0)
            this.setCssVariableForCollapsedHeader(-headerAppHeight)
          }
        }
        this.lastScrollY = currentScrollY
        const h = stickyStripeEnabled ? messageBarHeight : headerAppHeight - messageBarHeight
        if (this.lastScrollY < h) {
          this.setCssVariableForCollapsedHeader(0)
          this.offsets = {
            messageBar: parseInt(messageBarHeight),
            navigation: parseInt(headerAppHeight - messageBarHeight),
          }
        }
      } else {
        this.updateHeaderIsCollapsed(false)
        this.setCssVariableForVisibleHeaderOnScroll(0)
      }
    },
  },
}
